export default __webpack_public_path__ + "static/media/effra_std_rg-webfont.c383032d.woff";